module.exports = __webpack_public_path__ + "img/41.b383ba61.webp";